// Stylesheets
import "bootstrap/dist/css/bootstrap.min.css";
import "./Assets/Css/App.css";
import "./Assets/Css/IconHeader.css";
import "./Assets/Css/Logo.css";
import "./Assets/Css/Navigation.css";
import "./Assets/Css/HomeOverLay.css";
import "./Assets/Css/HomeAbout.css";
import "./Assets/Css/Footer.css";
import "./Assets/Css/HomeServicesOffered.css";
import "./Assets/Css/GoogleReviews.css";
import "./Assets/Css/Toast.css";
import "./Assets/Css/ContactUsForm.css";
import "./Assets/Css/PageOverLay.css";
import "./Assets/Css/AboutInfo.css";
import "./Assets/Css/ContactUs.css";
import "./Assets/Css/Testimonials.css";
import "./Assets/Css/Common.css";
import "./Assets/Css/NotFound.css";
import "./Assets/Css/Interested.css";
import "./Assets/Css/BlogArticles.css";
import "./Assets/Css/PuppyHome.css";
import "./Assets/Css/PuppyImages.css";
import "./Assets/Css/PuppyProfile.css";
import "./Assets/Css/PuppyProfileClassic.css";
import "./Assets/Css/EnhancedPuppyProfile.css";
import "./Assets/Css/InvestmentBreakdown.css";
import "./Assets/Css/MediaGallery.css";
import "./Assets/Css/VideoPlayer.css";
import "./Assets/Css/TrainingComparison.css";
import "./Assets/Css/PersonalityProfileComplex.css";
import "./Assets/Css/CustomPersonalityProfile.css";
import "./Assets/Css/CustomTrainingDetails.css";
import "./Assets/Css/Carousel.css";
import "./Assets/Css/YoutubeEmbed.css";

import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";

// Components
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ScrollToTop from "./ScrollToTop";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop>
          <App />
        </ScrollToTop>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
